import { DownArrowIcon } from "@xola/icons";
import { FormGroup, Label, PopoverList } from "@xola/ui-kit";
import { FieldProps, Field as FormikField } from "formik";
import React, { useState } from "react";
import { AgeField } from "./AgeField";
import { QuestionnaireModalType } from "@/models/Form/QuestionnaireModalType";

export const ValidationRuleField = ({ modalType }: { modalType: QuestionnaireModalType }) => {
    const [comparatorOpened, setComparatorOpened] = useState(false);

    if (modalType !== QuestionnaireModalType.BIRTH_DATE) {
        return null;
    }

    return (
        <FormGroup>
            <Label>Validation Rule</Label>
            <p className="space-x-2">
                <span>Age must be&nbsp;</span>
                <FormikField name="comparator">
                    {({ field: { value }, form }: FieldProps) => {
                        return (
                            <PopoverList visible={comparatorOpened} onClickOutside={() => setComparatorOpened(false)}>
                                <span className="cursor-pointer" onClick={() => setComparatorOpened(true)}>
                                    <span className="font-bold underline">{value === "older" ? ">=" : "<"}</span>
                                    <DownArrowIcon />
                                </span>

                                <PopoverList.Item
                                    name="older"
                                    onClickItem={() => form.setFieldValue("comparator", "older")}
                                >
                                    <span>&gt;=</span>
                                </PopoverList.Item>
                                <PopoverList.Item
                                    name="younger"
                                    onClickItem={() => form.setFieldValue("comparator", "younger")}
                                >
                                    <span>&lt;</span>
                                </PopoverList.Item>
                            </PopoverList>
                        );
                    }}
                </FormikField>
                <FormikField name="age">{(props: FieldProps) => <AgeField {...props} />}</FormikField>
            </p>
        </FormGroup>
    );
};
